import React from 'react';
import Icon, { Icons } from '../../components/Icon/Icon';

import './SwapButton.scss';

const SWAP_ICON_SIZE = 20;

const SwapButton = ({ onClick }) => {
	return (
		<button className='SwapButton'>
			<Icon
				className='SwapButton__icon'
				onClick={onClick}
				type={Icons.ARROW_UP_DOWN}
				width={SWAP_ICON_SIZE}
				height={SWAP_ICON_SIZE}
			/>
		</button>
	);
};

export default SwapButton;
